import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Radio, ArrowRight, MessageSquare, Zap } from 'lucide-react';
import styles from './Navbar.module.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Technology', href: '#about' },
    { name: 'Samples', href: '#samples' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'Services', href: '#services' },
  ];

  return (
    <nav className={`${styles.navbar} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.navContainer}>
        <a href="#home" className={styles.logo}>
          <span className={styles.logoText}>ANANTA</span>
          <div className={styles.logoDot} />
        </a>

        <div className={styles.desktopWrapper}>
          <div className={styles.navLinks}>
            {navLinks.map((link) => (
              <a key={link.name} href={link.href} className={styles.navLink}>
                {link.name}
              </a>
            ))}
          </div>
          <a href="#pricing" className={styles.ctaBtn}>
            FREE DEMO <Zap size={14} fill="currentColor" />
          </a>
        </div>

        <button className={styles.mobileToggle} onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div 
            className={styles.mobileMenuOverlay}
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25 }}
          >
            <div className={styles.menuContent}>
              <div className={styles.menuTickerBar}>
                <div className={styles.liveLabel}><Radio size={14} className={styles.pulse} /> LIVE MENU</div>
                <div className={styles.menuTickerText}>START YOUR NEWS CHANNEL • AI BROADCAST READY • </div>
              </div>

              <div className={styles.mobileLinksStack}>
                {navLinks.map((link, idx) => (
                  <motion.a
                    key={link.name}
                    href={link.href}
                    className={styles.mobileNavLink}
                    initial={{ x: 30, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.1 * idx }}
                    onClick={() => setIsOpen(false)} // Closes menu on click
                  >
                    <span className={styles.linkNum}>0{idx + 1}</span>
                    <span className={styles.linkTitle}>{link.name}</span>
                    <ArrowRight className={styles.arrow} size={20} />
                  </motion.a>
                ))}
              </div>

              <a href="https://wa.me/917533928185" className={styles.whatsappBtn}>
                <MessageSquare size={20} /> CHAT ON WHATSAPP
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;